import * as React from "react";
import { useTranslation } from "react-i18next";

import OverviewDashboard from "./OverviewDashboard";
import ApplicationLayout from "components/layout/ApplicationLayout";
import { VideoTutorialButton } from "components/modal/video-modal/video-tutorial-button/VideoTutorialButton";
import { VideoModal } from "components/modal/video-modal/VideoModal";
import { DASHBOARD_ROUTE } from "components/router/Routes";
import { TutorialVideoLink } from "domain/tutorialVideos";

export default function CustomDashboard(): JSX.Element {
    const { t } = useTranslation();
    const [showVideoModal, setShowVideoModal] = React.useState(false);
    return (
        <>
            <ApplicationLayout
                viewTitle={t("Overview.title")}
                view={<OverviewDashboard />}
                mainRoute={DASHBOARD_ROUTE}
                viewActions={<VideoTutorialButton onClick={() => setShowVideoModal(true)} />}
            />
            <VideoModal
                isOpen={showVideoModal}
                hideModal={() => setShowVideoModal(false)}
                linkUrl={TutorialVideoLink.DASHBOARD}
            />
        </>
    );
}
